
import { useEffect, useState } from 'react';
import { getSupabaseClient } from '@/integrations/supabase/client';
import { User } from '@supabase/supabase-js';
import { useAuth } from './use-auth';

export interface UserProfile {
  id: string;
  email: string;
  name?: string;
  avatar_url?: string;
  bio?: string;
  seller_profile_id?: string;
}

export const useUserProfile = () => {
  const { user: authUser } = useAuth();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!authUser) {
        setProfile(null);
        setLoading(false);
        return;
      }

      try {
        const supabaseClient = getSupabaseClient();
        
        // Get the user profile data
        const { data, error } = await supabaseClient
          .from('profiles')
          .select('*')
          .eq('id', authUser.id)
          .single();

        if (error) {
          console.error('Error getting profile:', error);
          setLoading(false);
          return;
        }

        // Set the user profile data
        setProfile({
          id: authUser.id,
          email: authUser.email || '',
          name: data?.name,
          avatar_url: data?.avatar_url,
          bio: data?.bio,
          seller_profile_id: data?.seller_profile_id
        });
      } catch (error) {
        console.error('Error in useUserProfile hook:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [authUser]);

  return {
    profile,
    loading,
    isAuthenticated: !!authUser
  };
};
